import { useContext, useEffect, useState } from "react";
import { FormControl, FormHelperText, MenuItem, TextField } from "@mui/material";
import inputFieldSize from "./inputFieldSize";
import { fetchShirtSides } from "../../service";
import { Context } from "../../Provider";
import InputRequired from "../../../common/InputRequired";

const SelectorShirtSizeField = ({ register, errors, setIsLoading, readOnly }) => {
    const { state } = useContext(Context);
    const { ftm } = state;
    const [ shirtSides, setShirtSides ] = useState([]);

    useEffect(() => {
        const getShirtSides = async () => {
            try {
                setIsLoading(true);
                const response = await fetchShirtSides();
                setShirtSides(response?.sizes || []);
            } catch (error) {
                console.error("Registration failed:", error);
            } finally {
                setIsLoading(false);
            }
        };

        getShirtSides();
    }, [setIsLoading]);

    return(
        <FormControl error={!!errors.ftm_t_shirt_size} fullWidth>
            <strong>Shirt size <InputRequired/></strong>
            <TextField
                size={inputFieldSize}
                select
                defaultValue={ftm?.ftm_t_shirt_size_id || "0"}
                {...register("ftm_t_shirt_size", { required: 'Shirt size is required' })}
                InputProps={{
                    readOnly: readOnly,
                }}
                sx={{
                    '& .MuiInputBase-root': {
                      backgroundColor: readOnly ? '#f5f5f5' : 'inherit', // light gray when readonly
                    },
                }}
            >
                <MenuItem value="0" disabled>Select shirt size</MenuItem>
                {shirtSides.map((size, index) => (
                    <MenuItem key={index} value={size.t_shirt_size_id}>{size.t_shirt_size_code} - {size.t_shirt_size_name}</MenuItem>
                ))}
            </TextField>
            {errors.ftm_t_shirt_size && (
                <FormHelperText>{errors.ftm_t_shirt_size.message}</FormHelperText>
            )}
        </FormControl>
    );
};

export default SelectorShirtSizeField;